module.exports = __webpack_public_path__ + "img/social-email.b4d1ad41.svg";